import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

import { ROUTES } from '@/constants';
import { useRouteScope } from '@/contexts/app-context/hooks';
import { useCachedRegionSeason } from '@/hooks';
import { useAuth } from '@/libs';
import { getFromLocalStorage } from '@/utils/localStorage';

import AppLoading from '../AppLoading/AppLoading';

export const MIN_LOADING_SCREEN_TIMEOUT = 1800;

const LoadingProvider = ({ children }: { children: ReactNode }) => {
  const auth = useAuth();
  const { pathname } = useLocation();
  const { value } = useCachedRegionSeason();
  const { regionId } = useRouteScope();

  const isUserPresent = Boolean(
    auth?.user ?? getFromLocalStorage<unknown>('access_data')
  );
  const hasRouteScope = Boolean(regionId);
  const isPendingAccess = pathname === ROUTES.PENDING_ACCESS;
  const showLoading =
    ((!value && !hasRouteScope) || !isUserPresent) && !isPendingAccess;

  const [keepLoadingScreen, setKeepLoadingScreen] = useState(showLoading);

  useEffect(() => {
    if (!showLoading) {
      setKeepLoadingScreen(false);
      return;
    }

    const timer = setTimeout(() => {
      setKeepLoadingScreen(false);
    }, MIN_LOADING_SCREEN_TIMEOUT);

    return () => clearTimeout(timer);
  }, [showLoading]);

  return (
    <>
      {(showLoading || keepLoadingScreen) && <AppLoading />}
      {children}
    </>
  );
};

export default LoadingProvider;
